/* Form submissions land in the shared "Prayojak/Ummeedvar Submission Form" Google Sheet:
   https://docs.google.com/spreadsheets/d/10kGs6Wgd7wBKVp-KTMnm4ctxbn0llVdidGPMXdFl8go/edit

   The endpoint is the "Brahmoid Website Forms" Apps Script web app (source in
   scripts/google-form-webapp.gs), deployed from ishaan@brahmoid.org. It maps form fields
   to the sheet's Hindi column headers and appends one row per submission. */

const FORM_ENDPOINT =
  process.env.REACT_APP_FORM_ENDPOINT ||
  'https://script.google.com/a/macros/brahmoid.org/s/AKfycbxi15DFbltaDGLkOA3zm411sX6a1mO0iE9y5Wh5F_quvrv1NAX4GbPtpiCsnc01fVidaQ/exec';

export const SUBMISSION_SHEET_URL =
  'https://docs.google.com/spreadsheets/d/10kGs6Wgd7wBKVp-KTMnm4ctxbn0llVdidGPMXdFl8go/edit';

/**
 * Send a form's fields to the submission sheet. Fire-and-forget: the Apps Script
 * endpoint is called with no-cors, so the response is opaque — we optimistically
 * report success to the visitor and keep a console record for debugging.
 * @param {'ummeedvar'|'prayojak'} formType which sheet tab the row lands in
 * @param {HTMLFormElement} form
 */
export function submitToSheet(formType, form) {
  const payload = {
    formType,
    submittedAt: new Date().toISOString(),
    page: window.location.href,
    ...Object.fromEntries(new FormData(form).entries()),
  };

  if (!FORM_ENDPOINT) {
    // Endpoint not configured yet — keep the submission visible for debugging.
    console.warn('[brahmoid] form endpoint not configured; submission not sent:', payload);
    return Promise.resolve(false);
  }

  return fetch(FORM_ENDPOINT, {
    method: 'POST',
    mode: 'no-cors',
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify(payload),
  })
    .then(() => true)
    .catch((err) => {
      console.error('[brahmoid] form submission failed:', err);
      return false;
    });
}
